import { render, staticRenderFns } from "./AddAttachmentTab.vue?vue&type=template&id=7cc2e42e&scoped=true&"
import script from "./AddAttachmentTab.vue?vue&type=script&lang=js&"
export * from "./AddAttachmentTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc2e42e",
  null
  
)

export default component.exports